export const prefix = 'administration.applications.modalDNC'
